import WhiteboardConfig from "@/WhiteboardConfig";
import shortUuid from "short-uuid";
import { getInitialUsername } from "../initialStateHelpers";
import makeTypeSafeCommitter from "../makeTypeSafeCommitter";

export interface UserState {
  isAnonymous: boolean;
  session: {
    readonly is_guest: boolean;
  };
  clientID: string;
  username: string;
}

const mutations = {
  setGuestUsername(state: UserState, name: string) {
    localStorage.guestUsername = name;
    state.username = name;
  },
};
type UserMutationsWithState = typeof mutations;

export const UserMutations = makeTypeSafeCommitter<UserState, typeof mutations>(
  mutations
);

const getters = {};
type UserGettersWithState = typeof getters;
export type UserGetters = {
  [Property in keyof UserGettersWithState]: ReturnType<
    UserGettersWithState[Property]
  >;
};

export function makeUserModule(config: WhiteboardConfig): {
  state: () => UserState;
  mutations: UserMutationsWithState;
  getters: UserGettersWithState;
} {
  return {
    state: () => ({
      isAnonymous: config.session.is_guest,
      session: config.session,
      clientID: shortUuid().new(),
      username: getInitialUsername(config),
    }),
    mutations,
    getters,
  };
}
